// resolveGateInfo — pure extraction of gate/terminal for a flight leg.
//
// Extracted verbatim from `FlightLookup.js` (module-level `resolveGateInfo`) as
// part of the behavior-preserving refactor (issue #240). Prefers the formatted
// `departure`/`arrival` gate and terminal, falling back to the raw
// `gate_origin`/`gate_destination` and `terminal_origin`/`terminal_destination`
// fields.
//
// Totality preserved exactly: a missing value resolves to `undefined` via the
// optional chaining and `||` fallback, matching the source. Always returns an
// object with `gate` and `terminal` keys.
//
// React-free and side-effect-free.
//
// Validates: Requirements 3.1, 3.4, 3.5, 1.6

/**
 * Extracts gate and terminal for a flight leg, falling back to raw fields.
 *
 * @param {Object} flight - Raw flight data from FlightAware.
 * @param {'departure'|'arrival'} type - Which leg to resolve.
 * @returns {{ gate: (string|undefined), terminal: (string|undefined) }} Gate/terminal info.
 */
export function resolveGateInfo(flight, type) {
  const isDeparture = type === 'departure';
  const formatted   = isDeparture ? flight.departure : flight.arrival;
  const gateFallback     = isDeparture ? flight.gate_origin     : flight.gate_destination;
  const terminalFallback = isDeparture ? flight.terminal_origin : flight.terminal_destination;

  return {
    gate:     formatted?.gate     || gateFallback,
    terminal: formatted?.terminal || terminalFallback,
  };
}

export default resolveGateInfo;
